import { BitkitDefinitionTooltip } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { Text } from '@chakra-ui/react/text';

import { DecoratedArtifact } from '@/models/Artifact';

import ArtifactDeviceList from '../../../../ArtifactElement/ArtifactDeviceList/ArtifactDeviceList';
import ArtifactNotificationSettings from '../../../../ArtifactElement/ArtifactNotificationSettings/ArtifactNotificationSettings';

type Props = {
  artifact: DecoratedArtifact;
};

const InstallableContent = ({ artifact }: Props) => {
  return (
    <Box display="flex" flexDir="column" gap="1rem">
      <Box display="grid" gridTemplateColumns="min-content min-content" columnGap="16">
        {artifact.appInfo.map((info, index) => {
          const valueKey = `value-${info.key}-${index}`;

          let value;
          if (info.description) {
            value = (
              <Text key={valueKey} textStyle="body/md/regular" color="text/secondary">
                <BitkitDefinitionTooltip text={info.description as string} textSize="md" truncate={false}>
                  {info.value as string}
                </BitkitDefinitionTooltip>
              </Text>
            );
          } else {
            value = (
              <Text key={valueKey} textStyle="body/md/regular" color="text/secondary">
                {info.value}
              </Text>
            );
          }

          return [
            <Text key={`info-${info.key}-${info.value}`} textStyle="sans/size-2/bold">
              {info.key}
            </Text>,
            value,
          ];
        })}
      </Box>

      {['ipa', 'apk'].includes(artifact.extension) && (
        <>
          <ArtifactNotificationSettings
            artifactId={artifact.id}
            notifiedEmailsProp={artifact.notifiedEmails}
            isPublicInstallPageEnabled={artifact.isPublicPageEnabled}
          />
          <ArtifactDeviceList devices={artifact.allowedTestDevices} />
        </>
      )}
    </Box>
  );
};

export default InstallableContent;
